export default __webpack_public_path__ + "static/ElectricVehicles-91d1e78624e18e7352d2b4636c7c857e.jpg";